
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class MetatronCubeEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
         const r = (200 + layerIndex * 100) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, r * 2.5);
        const scale = config.parallaxScale || 1.0;
        const curTime = time * 0.5 * config.parallaxSpeed;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * scale;

        const drawCube = (x: number, y: number, radius: number) => {
            const points: {x: number, y: number}[] = [];
            // Centers
            points.push({x, y});
            for (let i = 0; i < 6; i++) {
                const a = (i / 6) * Math.PI * 2 + curTime;
                points.push({x: x + Math.cos(a) * radius * 0.5, y: y + Math.sin(a) * radius * 0.5});
                points.push({x: x + Math.cos(a) * radius, y: y + Math.sin(a) * radius});
            }

            // Connect all points to each other
            for (let i = 0; i < points.length; i++) {
                for (let j = i + 1; j < points.length; j++) {
                    ctx.beginPath();
                    ctx.moveTo(points[i].x, points[i].y);
                    ctx.lineTo(points[j].x, points[j].y);
                    ctx.stroke();
                }
            }
        };

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.6;
            for (let x = x1; x <= x2; x += r * 2.5) {
                for (let y = y1; y <= y2; y += r * 2.5) {
                    drawCube(x, y, r * 0.8 * scale);
                }
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
